// extracted by mini-css-extract-plugin
export var promotionLink = "_tp-0";